// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
// Split-sibling label decoration. Rows sharing (label, service period
// start, service period end) are siblings; the "(n/total)" suffix is
// rendered here at display time, never stored on the label column.
import {
  ChargeFormDateValue,
  chargeDateKey,
} from '@/project/utilities/charge-date';

export function decorateChargeLabel(
  label: string,
  index: number,
  total: number
): string {
  if (total <= 1) return label;
  return `${label} (${String(index)}/${String(total)})`;
}

interface ChargeForGrouping {
  label: string;
  servicePeriodStart: ChargeFormDateValue;
  servicePeriodEnd: ChargeFormDateValue;
}

export function computeChargeDisplayLabels(
  charges: ChargeForGrouping[]
): string[] {
  const groups = new Map<string, number[]>();
  const keyFor = (c: ChargeForGrouping): string =>
    [
      c.label,
      chargeDateKey(c.servicePeriodStart) ?? '',
      chargeDateKey(c.servicePeriodEnd) ?? '',
    ].join('|');

  for (let i = 0; i < charges.length; i++) {
    const key = keyFor(charges[i]);
    const indices = groups.get(key) ?? [];
    indices.push(i);
    groups.set(key, indices);
  }

  const out: string[] = new Array<string>(charges.length);
  for (const indices of groups.values()) {
    const total = indices.length;
    for (let pos = 0; pos < indices.length; pos++) {
      const sourceIndex = indices[pos];
      out[sourceIndex] = decorateChargeLabel(
        charges[sourceIndex].label,
        pos + 1,
        total
      );
    }
  }
  return out;
}
